module.exports = __webpack_public_path__ + "img/login.d2e682fc.png";